module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAQCAYAAAD52jQlAAAACXBIWXMAAAsSAAALEgHS3X78AAAAvUlEQVQ4jdXUMQrCQBSE4X/jBpJlUUwnCvZewM5TeAyv4AksBe/kHSwsBC00gpolumbXC9g9Uzjw2g9migewAhwQf3AOWCmgKorCZFmGNHVdU5al04DJ8xxrrRhVSgGYRCx9SSuoXioYvj32+RRjD+85KNAzpRiFgG3eYvQeGg60VP9/UJ1OItk4knejGPM3SPegzRx600B/0IjR5Bg4b/9qU8A9Li8Tg3zT6uoBnI4Jm9OuWgDyNwUudlh/AD1vS5CLCLtGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/LangSelector/flag-de.png
// module id = 2269
// module chunks = 1